import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {AuthGuard} from './guards/auth.guard';
import {LoginGuard} from './guards/login.guard';
import {OrganisationsGuard} from './guards/organisations.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
    canActivate: [LoginGuard]
  },
  {
    path: 'organisations',
    loadChildren: () => import('./pages/organisations/organisations.module').then(m => m.OrganisationsPageModule),
    canActivate: [OrganisationsGuard],
    canDeactivate: [OrganisationsGuard]
  },
  {
    path: 'care-plan',
    loadChildren: () => import('./pages/cd/care-plan/care-plan.module').then(m => m.CarePlanPageModule)
  },
  {
    path: 'wound-management',
    loadChildren: () => import('./pages/wm/wound-management/wound-management.module').then(m => m.WoundManagementPageModule)
  },
  {
    path: 'identity-card',
    loadChildren: () => import('./pages/identity-card/identity-card.module').then( m => m.IdentityCardPageModule)
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
